<template>
    <div>
      <div class="contract-type primary--text py-2">{{ contractSelectTypeTitle }}</div> 
      <v-item-group v-model="indexSelectedPlan" class="my-0 pb-0"> 
          <v-row v-for="(service, index) in services"
              color="#ffffff"
              rounded
              class="plans mb-2 mx-0 mt-0 pa-3 rounded-lg d-flex justify-center align-center"
              :class="{ selected: indexSelectedPlan!==false && indexSelectedPlan!==undefined && service.id == services[indexSelectedPlan].service_id }"
              :key="service.id"
              justify="center"
              >
              <v-item v-slot="{ active, toggle }">
                <v-col cols="12" class="ma-0 pa-0" @click="toggle">
                    <v-row class="ma-0 pa-0 align-center">
                        <v-col cols="2" class="ma-0 pa-0">
                          <v-icon v-if="active">mdi-radiobox-marked</v-icon>
                          <v-icon v-else>mdi-radiobox-blank</v-icon>                                                                                
                        </v-col>
                        <v-col cols="7" class="ma-0 pa-0">
                            <v-row class="ma-0 pa-0">
                                <v-col cols="12" class="ma-0 pa-0">
                                    <p class="my-0 py-0">
                                        <span class="mark-price">{{ service.name }}</span>
                                    </p>
                                </v-col>
                                <v-col cols="12" class="ma-0 pa-0">
                                    <p class="my-0 py-0" v-if="contract_select_type=='invoices'">
                                        <span>Hasta {{ formatNumberES(service.yearly_documents) }} docs/año</span>
                                    </p>
                                    <p class="my-0 py-0" v-if="contract_select_type=='banks'">
                                        <span>Hasta {{ formatNumberES(service.yearly_transactions) }} movs/año</span>
                                    </p>
                                    <p class="my-0 py-0" v-if="contract_select_type=='credits'">
                                      <span>Hasta {{ formatNumberES(service.yearly_credits) }} creds/año</span>
                                    </p>
                                    <p class="my-0 py-0" v-if="contract_select_type=='facturae_credits'">
                                      <span>Selecciona número empresas</span>
                                    </p>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="3" class="ma-0 pa-0">
                            <v-row class="ma-0 pa-0">
                                <v-col cols="12" class="ma-0 pa-0">
                                    <span class="mark-time" v-if="true || service.duration.split(' ')[0] == '365'"><span class="mark-price">{{ formatNumberES(service.price,2) }} €</span><span v-if="contract_select_type=='facturae_credits'">/empresa-año</span><span v-else>/año</span></span>
                                </v-col>
                                <v-col cols="12" class="ma-0 pa-0">
                                    <p class="my-0 py-0">
                                        <span>(IVA no incluido)</span>
                                    </p>
                                </v-col>                              
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
              </v-item>
          </v-row>
      </v-item-group>
    </div>
</template>

<script>
import contracts from '@/store/modules/contracts';

export default {
  name: 'ContractSelectPlanPopup',
    components: {    
    },
    props: {
      contract_select_type: {
          type: String,
          default: 'invoices'
      },
      services: {
        type: Array,
        required: true
      },
      selected_plan: {
        type: Object,
        required: true
      }       
    },
    data () {
      return {
        /*        
        validationRules: {
            required: v => (v.toString()!='false') || 'Campo obligatorio',            
        },
        */        
      }
    },
    computed: {
      contractSelectTypeTitle: function () {
        if (this.contract_select_type == 'banks') {
          return 'BANCOS';
        }
        else if (this.contract_select_type == 'credits') {
          return 'GESTOR DOCUMENTAL';
        } 
        else if (this.contract_select_type == 'facturae_credits') {
          return 'FACTURA ELECTRÓNICA';
        }
        else {
          return 'FACTURAS';
        }        
      },
      indexSelectedPlan: {
        get(){
          if (this.contract_select_type == 'invoices') {
            return this.selected_plan.invoices;
          }
          else if (this.contract_select_type == 'credits') {
            return this.selected_plan.credits;
          }
          else if (this.contract_select_type == 'facturae_credits') {
            return this.selected_plan.facturae_credits;
          }
          else {
            return this.selected_plan.banks;
          }
        },
        set(newVal){
          if (this.contract_select_type == 'invoices') {
            this.selected_plan.invoices = newVal;
          }
          else if (this.contract_select_type == 'credits') {
            this.selected_plan.credits = newVal;
          }
          else if (this.contract_select_type == 'facturae_credits') {
            this.selected_plan.facturae_credits = newVal;
          }
          else {
            this.selected_plan.banks = newVal;
          }
        }

      }
    },
    methods: {      
      formatNumberES(nStr, d=0) {
          nStr += '';
          let x = nStr.split('.');
          let x1 = x[0];
          let x2 = x.length > 1 ? ',' + x[1] : '';
          var rgx = /(\d+)(\d{3})/;
          while (rgx.test(x1)) {
                  x1 = x1.replace(rgx, '$1' + '.' + '$2');
          }
          return x1 + x2;
      },        
    }
  }
</script>

<style lang="scss" scoped>
  .plans {
    cursor: pointer;
    font-size: 0.80rem;
    background-color:white;
    &.selected {
        background-color: #dedcff;
    }
    &.disabled {
        opacity: 50%;
    }
    span {
        margin: auto;
    }
    border: 1px solid #66369b;
  }
  button.btn-purple {
      color: #ffffff;
  }

  span.mark-time {
      font-size: 1rem;
      color: #66369b;
  }
  span.mark-price {
      font-size: 1.2rem;
      color: #66369b;
      font-weight: 500;
  }
</style>